/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleInfo
 */
export interface RoleInfo {
    /**
     * 
     * @type {boolean}
     * @memberof RoleInfo
     */
    crossTenant?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleInfo
     */
    roleId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleInfo
     */
    roleName?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleInfo
     */
    roleDisplayName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RoleInfo
     */
    isCrossTenant?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleInfo
     */
    relationshipId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleInfo
     */
    sourceTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleInfo
     */
    assignedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleInfo
     */
    expiresAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RoleInfo
     */
    active?: boolean;
}

/**
 * Check if a given object implements the RoleInfo interface.
 */
export function instanceOfRoleInfo(value: object): value is RoleInfo {
    return true;
}

export function RoleInfoFromJSON(json: any): RoleInfo {
    return RoleInfoFromJSONTyped(json, false);
}

export function RoleInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'crossTenant': json['crossTenant'] == null ? undefined : json['crossTenant'],
        'roleId': json['role_id'] == null ? undefined : json['role_id'],
        'roleName': json['role_name'] == null ? undefined : json['role_name'],
        'roleDisplayName': json['role_display_name'] == null ? undefined : json['role_display_name'],
        'isCrossTenant': json['is_cross_tenant'] == null ? undefined : json['is_cross_tenant'],
        'relationshipId': json['relationship_id'] == null ? undefined : json['relationship_id'],
        'sourceTenantId': json['source_tenant_id'] == null ? undefined : json['source_tenant_id'],
        'assignedAt': json['assigned_at'] == null ? undefined : json['assigned_at'],
        'expiresAt': json['expires_at'] == null ? undefined : json['expires_at'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function RoleInfoToJSON(json: any): RoleInfo {
    return RoleInfoToJSONTyped(json, false);
}

export function RoleInfoToJSONTyped(value?: RoleInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'crossTenant': value['crossTenant'],
        'role_id': value['roleId'],
        'role_name': value['roleName'],
        'role_display_name': value['roleDisplayName'],
        'is_cross_tenant': value['isCrossTenant'],
        'relationship_id': value['relationshipId'],
        'source_tenant_id': value['sourceTenantId'],
        'assigned_at': value['assignedAt'],
        'expires_at': value['expiresAt'],
        'active': value['active'],
    };
}

